import { CircleCheck } from "lucide-react";
// Transparent cutout of the celebrity that splits the two sides.
import celebCutout from "../../assets/images/whatwedo/celebrityMarketing/celeb.png";

const SIDES = [
  {
    title: "Match",
    sub: "Find the right celebrity.",
    points: [
      "We understand your goals, audience and brand.",
      "We identify the right celebrity fit.",
      "We recommend the best options.",
      "We handle outreach and discussions.",
    ],
  },
  {
    title: "Make it happen",
    sub: "End-to-end execution.",
    points: [
      "We manage negotiations and contracts.",
      "We handle logistics, travel and stays.",
      "We coordinate with teams, venues and partners.",
      "We ensure a smooth on-ground experience.",
    ],
  },
];

const Side = ({ num, title, sub, points }) => (
  <article className="cm-side">
    <span className="cm-side-num">0{num}</span>
    <h3>{title}</h3>
    <p>{sub}</p>
    <ul className="ee-checks">
      {points.map((point) => (
        <li key={point}>
          <CircleCheck size={16} /> {point}
        </li>
      ))}
    </ul>
  </article>
);

// One panel split in two by the celebrity, who breaks out of its top edge.
const CelebSides = () => (
  <section className="ee-section">
    <div className="container">
      <span className="ee-eyebrow ee-eyebrow--line">Two sides, one complete solution</span>
      <div className="cm-sides" data-aos="fade-up" data-aos-once="true">
        <Side num={1} {...SIDES[0]} />
        <div className="cm-sides-figure" aria-hidden="true">
          <img loading="lazy" decoding="async" src={celebCutout} alt="" />
        </div>
        <Side num={2} {...SIDES[1]} />
      </div>
    </div>
  </section>
);

export default CelebSides;
